// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"b80318515e3088efa127","256":"4b711d373e59e466f1b2","532":"bf7f287edc29901274bb"}[chunkId] + ".js";
};